/**
 * Tabs Block — frontend tab switching.
 *
 * Replaces the previous Preline (data-hs-tab) dependency with vanilla JS
 * wired to the BEM classes and IDs from render.php.
 */

document.addEventListener( 'DOMContentLoaded', () => {
    document.querySelectorAll( '.wp-block-jormi-blocks-tabs' ).forEach( ( block ) => {
        const buttons = Array.from( block.querySelectorAll( '.wp-block-jormi-blocks-tabs__nav-item' ) );
        const panels  = Array.from( block.querySelectorAll( '.wp-block-jormi-blocks-tabs__panel' ) );

        if ( ! buttons.length || ! panels.length ) return;

        buttons.forEach( ( btn, index ) => {
            btn.addEventListener( 'click', () => {
                // Update button states
                buttons.forEach( ( b, i ) => {
                    b.classList.toggle( 'is-active', i === index );
                    b.setAttribute( 'aria-selected', i === index ? 'true' : 'false' );
                } );

                // Update panel visibility
                panels.forEach( ( panel, i ) => {
                    panel.classList.toggle( 'hidden', i !== index );
                } );
            } );
        } );
    } );
} );